export const ITEMS_PER_PAGE = 50;

// HOW MANY ACKNOWLEDGED PUSH DELIVERY RECEIPTS ARE REMEMBERED FOR DEDUPLICATION
export const RECEIVED_NOTIFICATIONS_LIMIT = 50;

export enum PharmacyLegendVariant {
  posted = 'posted',
  requested = 'requested',
  booked = 'booked',
}

export enum PharmacyLegendIntermediate {
  pending = 'pending',
}

export const emailRegex =
  /^(([a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const accountNumberRegex = /^(\**[0-9]*)$/;
export const taxRegex = /^[a-zA-Z0-9-\s]*$/;
export enum MonthlyYearlyRecurrence {
  day = 'onDay',
  weekdaysAndMonths = 'weekdaysAndMonths',
}

export enum MonthlyYearlyRecurrenceDropdown {
  onDayOfTheMonth = 'onDay',
  onTheMontheOfTheYear = 'onThe',
  onTheDay = 'onTheDay',
  onTheMonth = 'onTheMonth',
}

export enum Ordinals {
  first = 1,
  second = 2,
  third = 3,
  fourth = 4,
}

export enum SocialLoginType {
  google = 1,
  facebook = 2,
  apple = 3,
}

export enum PharmacistLegendVariant {
  availability = 'availability',
  requested = 'requested',
  booked = 'booked',
  workshift = 'workshift',
  vacation = 'vacation',
}

export enum TypeOfUser {
  pharmacy = 'Pharmacy',
  pharmacist = 'Pharmacist',
  admin = 'Admin',
  superAdmin = 'SuperAdmin',
  pharmacyAdmin = 'CompanyPharmacy',
  technician = 'Technician',
  student = 'Student',
}

export enum TypeOfUserCapital {
  pharmacy = 'Pharmacy',
  pharmacist = 'Pharmacist',
}

export enum HelpTypes {
  pharmacist = '11',
  pharmacy = '10',
  pharmacyAdmin = '9',
  students = '16',
  technicians = '14',
}

export const HelpUserTypes = {
  [HelpTypes.pharmacist]: TypeOfUser.pharmacist,
  [HelpTypes.pharmacy]: TypeOfUser.pharmacy,
  [HelpTypes.students]: TypeOfUser.student,
  [HelpTypes.technicians]: TypeOfUser.technician,
};

export enum AdminTypes {
  admin = 1,
  superadmin = 2,
}

export enum RequestStatusTypes {
  notStarted = 'notStarted',
  fulfilled = 'fulfilled',
  rejected = 'rejected',
  pending = 'pending',
}

export enum BottomSheetTypes {
  calendar = 'calendar',
  legendList = 'legendList',
  dashboardPharmacistFilter = 'dashboardPharmacistFilter',
  promoDetails = 'promoDetails',
  actionSheet = 'actionSheet',
  reportFilter = 'reportFilter',
  replacementFilter = 'replacementFilter',
  addNote = 'addNote',
  sortSheet = 'sortSheet',
  incomeFilter = 'incomeFilter',
}

export enum CalendarView {
  monthView = 'Month',
  weekRangeView = 'WeekRange',
  weekView = 'Week',
}

export enum PharmacistReportTypes {
  booking = 'booked',
  requested = 'requested',
  myAvailabilities = 'myAvailabilities',
  availableWorkshifts = 'availableWorkshifts',
  incomeReport = 'incomeReport',
  watchlist = 'watchlist',
  vacation = 'vacation',
}

export enum AdditionalReports {
  replacements = 'replacements',
}

export enum ReportRequestTypes {
  booked = 'booked',
  income = 'income',
  requested = 'requested',
  availability = 'availability',
  workshift = 'workshift',
  watchlist = 'watchlist',
  vacation = 'vacation',
  payment = 'payment',
  invoice = 'invoice',
}

export enum PharmacyBookingStatus {
  booked = 1,
}

export enum PharmacyFilterWorkshifts {
  posted = '0',
  request = '1',
  booked = '2',
  unfulfilled = '3',
}

export enum PharmacyWorkshiftStatus {
  posted = 'posted',
  request = 'requested',
  booked = 'booked',
  unfulfilled = 'unfulfilled',
}

export enum DashboardType {
  calendar = 'calendar',
  map = 'map',
}

export enum CalendarStateKey {
  month = 'month',
  day = 'day',
  week = 'week',
}

export enum PharmacyReportTypes {
  workshiftReport = 'postedWorkshiftReport',
  bookingReport = 'bookingReport',
  chargesReport = 'chargesReport',
}

export enum ReportStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Refused = 'Refused',
  Canceled = 'Canceled',
}

export enum recurrenceType {
  Never = 0,
  EveryDay = 1,
  EveryWeekday = 2,
  EveryWeek = 3,
  EveryMonth = 4,
  EveryYear = 5,
  Weekend = 6,
}

export const recurrenceWeekDays: Record<string, string> = {
  sunday: '0',
  monday: '1',
  tuesday: '2',
  wednesday: '3',
  thursday: '4',
  friday: '5',
  saturday: '6',
};

export const frenchCalendar = {
  monthNames: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ],
  monthNamesShort: [
    'Jan.',
    'Fév.',
    'Mar.',
    'Avr.',
    'Mai',
    'Jui.',
    'Juil.',
    'Aoû.',
    'Sep.',
    'Oct.',
    'Nov.',
    'Déc.',
  ],
  dayNames: [
    'Dimanche',
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi',
  ],
  dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
  today: "Aujourd'hui",
};

export enum responseType {
  success = 'Success',
  noData = 'No Data',
  failure = 'Failure',
  network = 'Network Error',
}

export enum errorType {
  error = 1,
  tokenExpired = 2,
  EnforceUpdatePassword = 3,
  handleCustom = 4,
  deletedAccount = 6,
  enforceAppUpdate = 7,
  permissionDenied = 8,
  refreshConfigurations = 9,
  forceLogout = 10,
  noError = 0,
  networkError = -1,
}

export enum RecurrenceActions {
  series = 'series',
  occurence = 'occurence',
}

export enum RecurrenceEvents {
  delete = 'delete',
  update = 'update',
}

export enum UpdateEventTypes {
  single = 'single',
  recurrenceSingle = 'recurrenceSingle',
  recurrenceSeries = 'recurrenceSeries',
}

export enum RefreshScreens {
  calendar = 'calendar',
  reports = 'reports',
}
export enum ReleaseDate {
  // Use this format YYYY-MM-DD
  mobile = '2026-09-22',
  web = '2026-09-22',
}

export const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~])[A-Za-z\d!@#$%^&*()_\-+=\[\]{};:'",.<>?/\\|`~]{8,}$/;
export enum ConfirmationTypes {
  pharmaPlanInvitation = 'pharmaPlanInvitation',
  booking = 'booking',
  availability = 'availability',
  rejectBooking = 'rejectBooking',
  addCredits = 'addCredits',
  cancelTAndCModal = 'cancelTAndCModal',
  deleteWorkshift = 'deleteWorkshift',
  updateTiming = 'updateTiming',
  counterOfferConfirm = 'counterOfferConfirm',
  closeChat = 'closeChat',
  makeChannelAvailable = 'makeChannelAvailable',
  counterOfferCancel = 'counterOfferCancel',
  enforceUpdate = 'enforceUpdate',
  continueCreation = 'continueCreation',
  adminContinueCreation = 'adminContinueCreation',
  softwareWarning = 'softwareWarning',
  userDelete = 'userDelete',
  expressBooking = 'expressBooking',
  hidePharmacist = 'hidePharmacist',
  activateUser = 'activateUser',
  promoExistUser = 'promoExistUser',
  createBroadcastGroupLeads = 'createBroadcastGroupLeads',
  deleteEntry = 'deleteEntry',
  takeOwnership = 'takeOwnership',
  publishConfiguration = 'publishConfiguration',
  unPublishConfiguration = 'unPublishConfiguration',
  markIncompatible = 'markIncompatible',
  markCompatible = 'markCompatible',
  unhidePharmacist = 'unhidePharmacist',
  permanentDelete = 'permanentDelete',
  editEmail = 'editEmail',
  editAccountNumber = 'editAccountNumber',
  createMultipleAvailabilities = 'createMultipleAvailabilities',
  changeEmail = 'changeEmail',
  resetSelection = 'resetSelection',
  sendNotification = 'sendNotification',
  removeWatchlist = 'removeWatchlist',
  vacations = 'vacations',
  availabilitiesConflict = 'availabilitiesConflict',
  cancelSubscription = 'cancelSubscription',
  planToUpgrade = 'planToUpgrade',
  approveRefund = 'approveRefund',
  clearAll = 'clearAll',
  reactivateSubscription = 'reactivateSubscription',
  deleteMultipleContracts = 'deleteMultipleContracts',
  assignOwnership = 'assignOwnership',
  changeOwnership = 'changeOwnership',
}

export enum TimeFormat {
  twentyFourHours = 0,
  twelveHours = 1,
}
export enum AvailabilityTypes {
  tempAvailability = 'tempAvailability',
  newVacation = 'newVacation',
}

export enum TypeOfJS {
  string = 'string',
  object = 'object',
}

export const googleGeocode = (
  latitude: number,
  longitude: number,
  apiKey: string,
) =>
  `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`;

export enum AllowanceTypes {
  notCovered = '0',
  covered = '1',
  custom = '2',
  travel = '3',
  accommodation = '4',
}

export enum SecondaryInputTypes {
  field = 'field',
  dropdown = 'dropdown',
}

export enum ServiceTypes {
  self = 'self',
  full = 'full',
}

export enum TypeOfSummary {
  workshiftDetails = 'workshiftDetails',
  pharmacist = 'pharmacist',
}

export enum BookingState {
  None = 0,
  PendingWithPharmacist = 1,
  UpdatedTiming = 2,
}

export const AllowancesNames = {
  paidHourlyRate: 'paidHourlyRate',
  weekDayPaidHourlyRate: 'weekDayPaidHourlyRate',
  weekendPaidHourlyRate: 'weekendPaidHourlyRate',

  travelAllowanceType: 'travelAllowanceTypes',
  accommodationAllowanceType: 'accommodationAllowanceType',
  mealAllowanceType: 'mealAllowanceType',

  minFreeTravelDistance: 'minFreeTravelDistance',
  travelAllowanceRatePerKm: 'travelAllowanceRatePerKm',
  fixedAccommodationRate: 'fixedAccommodationRate',
  fixedMealRate: 'fixedMealRate',
  travelAllowanceAmount: 'travelAllowanceAmount',
  accommodationAllowance: 'accommodationAllowance',
  mealAllowance: 'mealAllowance',
  emergencyFees: 'emergencyFees',
  otherAllowance: 'otherAllowance',

  // TODO: FOR COUNTER OFFER TEMPORARY
  fixedTravelAmount: 'fixedTravelAmount',
  fixedAccommodationAmount: 'fixedAccommodationAmount',
  hourlyRate: 'hourlyRate',
};

export const AdminAllowanceNames = {
  mealAllowance: 'mealAllowance',
  travelAllowance: 'travelAllowance',
  accommodationAllowance: 'accommodationAllowance',
  emergencyFees: 'emergencyFees',
  paidHourlyRate: 'paidHourlyRate',
  pharmacyHourlyRate: 'pharmacyHourlyRate',
  pharmacistHourlyRate: 'pharmacistHourlyRate',
  pharmacyWeekDayHourlyRate: 'pharmacyWeekDayHourlyRate',
  pharmacyWeekendHourlyRate: 'pharmacyWeekendHourlyRate',
  promoHourlyRate: 'promoHourlyRate',
  hourlyRateBonus: 'hourlyRateBonus',
};

export const SupportedTimezones = {
  EDT: 'EDT',
  CANADA: 'Canada/Eastern',
  EST: 'EST',
};

export const adminValuesToBeParsed = [
  AdminAllowanceNames.emergencyFees,
  AdminAllowanceNames.mealAllowance,
  AdminAllowanceNames.travelAllowance,
  AdminAllowanceNames.paidHourlyRate,
  AdminAllowanceNames.accommodationAllowance,
];

export const valueCriteria = {
  [AllowancesNames.minFreeTravelDistance]: {
    checkFrom: AllowancesNames.travelAllowanceType,
    shouldBe: AllowanceTypes.custom,
  },
  [AllowancesNames.travelAllowanceRatePerKm]: {
    checkFrom: AllowancesNames.travelAllowanceType,
    shouldBe: AllowanceTypes.custom,
  },
  [AllowancesNames.fixedAccommodationRate]: {
    checkFrom: AllowancesNames.accommodationAllowanceType,
    shouldBe: AllowanceTypes.custom,
  },
  [AllowancesNames.fixedMealRate]: {
    checkFrom: AllowancesNames.mealAllowanceType,
    shouldBe: AllowanceTypes.custom,
  },
};

export const keyToParse = [
  AllowancesNames.paidHourlyRate,
  AllowancesNames.minFreeTravelDistance,
  AllowancesNames.travelAllowanceRatePerKm,
  AllowancesNames.fixedAccommodationRate,
  AllowancesNames.fixedMealRate,
  AllowancesNames.emergencyFees,
];

export const AdminKeyToParse = [
  AdminAllowanceNames.emergencyFees,
  AdminAllowanceNames.paidHourlyRate,
  AdminAllowanceNames.travelAllowance,
  AdminAllowanceNames.mealAllowance,
  AdminAllowanceNames.accommodationAllowance,
  AdminAllowanceNames.pharmacyHourlyRate,
];

export const counterOfferCriteria = () => {
  const {
    [AllowancesNames.minFreeTravelDistance]: _,
    [AllowancesNames.travelAllowanceRatePerKm]: __,
    ...rest
  } = valueCriteria;
  rest[AllowancesNames.fixedTravelAmount] = {
    checkFrom: AllowancesNames.travelAllowanceType,
    shouldBe: AllowanceTypes.custom,
  };
  return rest;
};

export const areValuesDifferent = (
  first: number | string,
  second: number | string,
) => {
  return first !== second;
};
export enum TypeOfBill {
  bill = 'bill',
  finalBill = 'finalBill',
  counterOffer = 'counterOffer',
}

export const convertToDecimals = (value: number | undefined | null) =>
  (value ?? 0) % 1 !== 0 ? value?.toFixed?.(2) : (value ?? 0);

export const volumeRegex = /^\d+(?:\s*-\s*\d+)?$/;

export enum NotificationsType {
  // ALL NEGATIVE CASES
  // ICON: CANCEL CALENDAR | ACTION: GO TO CALENDAR
  PharmacistBookingCancellation = 14,
  PharmacyBookingCancellation = 15,
  BookingRequestCancellation = 3,
  PharmacyRejectedBooking = 5,
  PharmacistRejectedShift = 13,
  FullServiceBookingCancelled = 25,
  FullServiceRequestRejected = 30,
  FullServiceWatchlistInvalid = 31,

  // ALL DELETE CASES
  // ICON: TRASH CAN | ACTION: GO TO CALENDAR
  WorkshiftDelete = 10,

  // ALL UPDATE CASES
  // ICON: TICKER | ACTION: GO TO WORKSHIFT
  PharmacyRejectedShift = 16,
  PharmacistReminder2ApproveBooking = 17,
  GenerateInvoiceReminder = 8,
  WorkshiftUpdate = 9,
  BookedWorkshiftUpdate = 11,
  CounterOfferSubmission = 2,
  FullServiceBookedTimeUpdate = 27,
  FullServiceBookedRateAllowanceUpdate = 28,
  FullServiceBookedUpdate = 29,
  FullServiceWatchlistRateAllowanceUpdate = 32,
  FullServiceWatchlistTimeUpdate = 33,
  FullServiceWatchlistUpdate = 34,
  FullServiceChangedPharmacist = 26,
  FullServicePharmacyBookedReminder = 35,
  FullServicePharmacistBookedReminder = 36,
  MultiDayShiftReminder = 58,
  PharmacyUpdatedMultiShift = 53,

  // ALL POSITIVE CASES
  // ICON: GREEN TICK | ACTION: GO TO WORKSHIFT
  Unknown = 0,
  BookingRequest = 1,
  RequestedMultiDayShifts = 38,
  PharmacistRequestedMultiDayShift = 46,
  RequestedCounterMultiDayShift = 40,
  PharmacyApprovedBooking = 4,
  BroadcastNotification = 64,
  PharmacistApprovedBooking = 6,
  PharmacistApprovedBookedTimings = 12,
  FullServiceApproveBooking = 24,
  MultiShiftBookingComplete = 43,
  PharmacistSubmittedCounter = 7,
}

export enum NotificationGroups {
  negative = 1,
  positive = 2,
  update = 3,
  delete = 4,
  custom = 5,
}

export enum PositiveIcons {
  tick = 'tick',
  cancel = 'cancel',
}

export const NotificationsMap = {
  // NEGATIVE
  [NotificationsType.PharmacyBookingCancellation]: NotificationGroups.negative,
  [NotificationsType.PharmacyRejectedShift]: NotificationGroups.negative,
  [NotificationsType.PharmacyRejectedBooking]: NotificationGroups.negative,
  [NotificationsType.Unknown]: NotificationGroups.negative,
  [NotificationsType.FullServiceBookingCancelled]: NotificationGroups.negative,
  [NotificationsType.FullServiceRequestRejected]: NotificationGroups.negative,
  [NotificationsType.FullServiceWatchlistInvalid]: NotificationGroups.negative,
  [NotificationsType.BookingRequestCancellation]: NotificationGroups.negative,
  // DELETE
  [NotificationsType.WorkshiftDelete]: NotificationGroups.delete,

  // UPDATE
  [NotificationsType.PharmacistReminder2ApproveBooking]:
    NotificationGroups.update,

  [NotificationsType.WorkshiftUpdate]: NotificationGroups.update,
  [NotificationsType.BookedWorkshiftUpdate]: NotificationGroups.update,
  [NotificationsType.FullServiceBookedTimeUpdate]: NotificationGroups.update,
  [NotificationsType.FullServiceBookedRateAllowanceUpdate]:
    NotificationGroups.update,
  [NotificationsType.FullServiceBookedUpdate]: NotificationGroups.update,
  [NotificationsType.FullServiceWatchlistRateAllowanceUpdate]:
    NotificationGroups.update,
  [NotificationsType.FullServiceWatchlistTimeUpdate]: NotificationGroups.update,
  [NotificationsType.FullServiceWatchlistUpdate]: NotificationGroups.update,
  [NotificationsType.FullServiceChangedPharmacist]: NotificationGroups.update,
  [NotificationsType.MultiDayShiftReminder]: NotificationGroups.update,
  [NotificationsType.PharmacyUpdatedMultiShift]: NotificationGroups.update,

  // POSTITIVE
  [NotificationsType.BroadcastNotification]: NotificationGroups.positive,
  [NotificationsType.PharmacistRequestedMultiDayShift]:
    NotificationGroups.positive,
  [NotificationsType.RequestedCounterMultiDayShift]:
    NotificationGroups.positive,
  [NotificationsType.MultiShiftBookingComplete]: NotificationGroups.positive,
  [NotificationsType.PharmacistBookingCancellation]:
    NotificationGroups.positive,
  [NotificationsType.PharmacistRejectedShift]: NotificationGroups.negative,
  [NotificationsType.PharmacistSubmittedCounter]: NotificationGroups.positive,
  [NotificationsType.BookingRequest]: NotificationGroups.positive,
  [NotificationsType.CounterOfferSubmission]: NotificationGroups.positive,
  [NotificationsType.PharmacyApprovedBooking]: NotificationGroups.positive,
  [NotificationsType.PharmacistApprovedBooking]: NotificationGroups.positive,
  [NotificationsType.PharmacistApprovedBookedTimings]:
    NotificationGroups.positive,
  [NotificationsType.FullServiceApproveBooking]: NotificationGroups.positive,
  [NotificationsType.FullServicePharmacyBookedReminder]:
    NotificationGroups.update,
  [NotificationsType.FullServicePharmacistBookedReminder]:
    NotificationGroups.update,
  [NotificationsType.RequestedMultiDayShifts]: NotificationGroups.positive,
  // CUSTOM
  [NotificationsType.GenerateInvoiceReminder]: NotificationGroups.custom,
};

type INotificationIdMapType = Record<
  string,
  {
    idType: string;
    type: PharmacyLegendVariant | PharmacistLegendVariant;
    iconType?: PositiveIcons;
    bookingState: BookingState;
  }
>;

export const NotificationIdMap: INotificationIdMapType = {
  [NotificationsType.BookingRequest]: {
    idType: 'workshiftId',
    type: PharmacyLegendVariant.requested,
    iconType: PositiveIcons.tick,
    bookingState: BookingState.None,
  },
  [NotificationsType.BroadcastNotification]: {
    idType: '',
    type: PharmacistLegendVariant.workshift,
    iconType: PositiveIcons.tick,
    bookingState: BookingState.None,
  },
  [NotificationsType.PharmacyApprovedBooking]: {
    idType: 'bookingId',
    type: PharmacistLegendVariant.requested,
    bookingState: BookingState.PendingWithPharmacist,
  },
  [NotificationsType.PharmacistApprovedBooking]: {
    idType: 'bookingId',
    type: PharmacistLegendVariant.booked,
    bookingState: BookingState.None,
  },
  [NotificationsType.PharmacistApprovedBookedTimings]: {
    idType: 'bookingId',
    type: PharmacistLegendVariant.booked,
    bookingState: BookingState.None,
  },
  [NotificationsType.PharmacistReminder2ApproveBooking]: {
    idType: 'bookingId',
    type: PharmacistLegendVariant.requested,
    bookingState: BookingState.PendingWithPharmacist,
  },
  [NotificationsType.WorkshiftUpdate]: {
    idType: 'workshiftId',
    type: PharmacistLegendVariant.workshift,
    iconType: PositiveIcons.tick,
    bookingState: BookingState.None,
  },
  [NotificationsType.BookedWorkshiftUpdate]: {
    idType: 'bookingId',
    type: PharmacistLegendVariant.booked,
    bookingState: BookingState.UpdatedTiming,
  },
  [NotificationsType.CounterOfferSubmission]: {
    idType: 'workshiftId',
    type: PharmacistLegendVariant.requested,
    iconType: PositiveIcons.tick,
    bookingState: BookingState.None,
  },
  [NotificationsType.PharmacistBookingCancellation]: {
    idType: 'workshiftId',
    iconType: PositiveIcons.cancel,
    type: PharmacyLegendVariant.posted,
    bookingState: BookingState.None,
  },
  // [NotificationsType.PharmacistRejectedBookedTimings]: {
  //   idType: 'bookingId',
  //   iconType: PositiveIcons.cancel,
  //   type: PharmacyLegendVariant.booked,
  //   bookingState: BookingState.None,
  // },
  [NotificationsType.PharmacistSubmittedCounter]: {
    idType: 'workshiftId',
    iconType: PositiveIcons.tick,
    type: PharmacyLegendVariant.requested,
    bookingState: BookingState.None,
  },
  [NotificationsType.BookingRequestCancellation]: {
    idType: 'workshiftId',
    iconType: PositiveIcons.cancel,
    type: PharmacyLegendVariant.posted,
    bookingState: BookingState.None,
  },
};

export const showConfirmFor = [
  NotificationsType.PharmacistSubmittedCounter,
  NotificationsType.CounterOfferSubmission,
  NotificationsType.PharmacistApprovedBooking,
  NotificationsType.BookingRequest,
  NotificationsType.PharmacistReminder2ApproveBooking,
];

export const defaultCenter = {
  lat: 45.5019,
  lng: -73.5674,
};

export enum Language {
  en = 'en',
  fr = 'fr',
}

export const totalRatingValue = '5';

export enum ColorScheme {
  auto = 0,
  light = 1,
  dark = 2,
}

export interface UserTypings<T> {
  [TypeOfUser.pharmacy]: T;
  [TypeOfUser.pharmacist]: T;
  [TypeOfUser.admin]?: T | any;
  [TypeOfUser.superAdmin]?: T | any;
  [TypeOfUser.pharmacyAdmin]?: T | any;
  [TypeOfUser.technician]?: T | any;
  [TypeOfUser.student]?: T | any;
}

export const toType = <T,>(val: unknown) => val as keyof T;
export const ToUserTypings = <T,>(obj: UserTypings<T>) => obj;

export enum PendingActivationTypes {
  deletedUsers = 'deletedUsers',
}

export type PendingTabTypes = HelpTypes | PendingActivationTypes;

export enum PendingCancellationTabTypes {
  pendingCancellations = 'pendingCancellations',
  cancelledBookings = 'cancelledBookings',
  rejectedCancellations = 'rejectedCancellations',
}

export enum PendingRequestTabTypes {
  pendingRefunds = 'pendingRefunds',
}

export enum PendingCancellationStatus {
  Critical = 'Critical',
  Normal = 'Normal',
  Severe = 'Severe',
  Urgent = 'Urgent',
}

export const PendingCancellationDetailsRouteTypes = {
  [PendingCancellationTabTypes.pendingCancellations]: 'pending-cancellations',
  [PendingCancellationTabTypes.cancelledBookings]: 'cancelled-bookings',
  [PendingCancellationTabTypes.rejectedCancellations]: 'rejected-cancellations',
};

export const appName = {
  [ServiceTypes.self]: 'PharmaGap',
  [ServiceTypes.full]: 'PharmaPlan',
};

export enum WorkshiftStatus {
  Posted = 0,
  Requested = 1,
  Booked = 2,
  Unfulfilled = 3,
  NotAvailable = 4,
}

export enum WorkshiftReportStatus {
  posted = 0,
  request = 1,
  booked = 2,
  unfulfilled = 3,
  pariallyUnfulfilled = 4,
  partiallyBooked = 5,
  partiallyRequested = 6,
  partiallyRequestedBooked = 7,
}

export enum AvailabilitiesReportStatus {
  Free = 'Free',
  Booked = 'Booked',
}

export enum PermissionsOfAdmin {
  Activation = 1,
  Posting = 2,
  Booking = 3,
  Delete = 4,
  ChangeParameters = 5,
  SetupIncompatibleMatch = 6,
  LogsView = 7,
  BroadcastNotification = 8,
  AdministratorList = 9,
  GlobalSetting = 10,
  PermanentDelete = 11,
  PharmacyAdmin = 12,
  ViewEngagedChat = 13,
  PharmacyProfessionalChat = 14,
  PendingRefunds = 15,
  AdditionalCreditAllocation = 17,
  CrossPlatformSettings = 18,
  EditConfiguration = 19,
}

export enum PermissionsRemovalKeys {
  ApproveBooking = 'ApproveBooking',
  ExpressBooking = 'ExpressBooking',
  Edit = 'Edit',
  Deactivate = 'Deactivate',
  Hide = 'Hide',
  Actions = 'Actions',
  Delete = 'Delete',
  PermanentDelete = 'PermanentDelete',
  CreateAvailability = 'CreateAvailability',
  CreateMultipleAvailability = 'CreateMultipleAvailability',
}

export enum MiscType {
  All = 'All',
  None = 'None',
}

export const handleAll = <T,>(value: T | MiscType) =>
  value === MiscType.All ? '' : value;

export enum BroadcastNotificationType {
  email = 1,
  pushNotification = 2,
  message = 3,
  chat = 4,
}

export enum NavigateToType {
  ShiftURL = 0,
  Pharmacy = 1,
}

export const currency = '$';
export const distanceUnit = 'km';

export const perHour = '/Hr';

export enum LogActionTypes {
  create = 1,
  delete = 2,
  update = 3,
  booking = 4,
  cancelBooking = 5,
  updateTime = 6,
  updateRateAndAllowance = 7,
  cancelBookingRequest = 8,
}

export enum PerformerTypes {
  admin = 1,
  superAdmin = 2,
  pharmacyAdmin = 9,
  pharmacy = 10,
  pharmacist = 11,
  students = 16,
  technicians = 14,
}

export enum ActivityLogActionTypes {
  Create = 0,
  Update = 1,
  Delete = 2,
  Activate = 3,
  Deactivate = 4,
  Hide = 5,
  Unhide = 6,
  Approve = 7,
  Reject = 8,
  Cancel = 9,
  Upload = 10,
  AppointPharmacyAdministrator = 11,
  RatePharmacist = 12,
  AcceptBookingPharmacist = 13,
}

export enum ActivityLogModuleTypes {
  None = 0,
  Admin = 1,
  Pharmacy = 2,
  Pharmacist = 3,
  Workshift = 4,
  Availability = 5,
  Booking = 6,
  Cancellation = 7,
  NewAccount = 8,
  Incompatibility = 9,
  ExpressBooking = 10,
  Software = 11,
  PharmacistCapacity = 12,
  Banner = 13,
  ContactPreference = 14,
  GlobalSettings = 15,
  SFAdmin = 16,
  AdminNotes = 17,
  BroadcastGroup = 18,
  Broadcast = 19,
  Resume = 20,
  Permanently = 21,
}

export enum LoginType {
  pharmaplan = '0',
}

export const representNullValue = '-';

export enum AddEventType {
  Availabilities = 'Availabilities',
  Vacations = 'Vacations',
}

export const allDayStart = 8;
export const allDayEnd = 22;

export enum SelectionType {
  multiple = 'multiple',
  single = 'single',
  range = 'range',
}

export enum ChatStatus {
  available,
  engaged,
  assignedToMe,
  away,
}

export enum ChatMessageTypes {
  ChatClosed = 'ChatClosed',
}

export enum PlatformTypes {
  Other,
  Web,
  Mobile,
}

export enum WatchlistedVariants {
  interactive = 'interactive',
  static = 'static',
}

export enum MetaDataKeys {
  users = 'users',
  user_type = 'user_type',
  personnelId = 'personnelId',
  username = 'username',
}

export const imageTypes = {
  jpeg: 'image/jpeg',
  png: 'image/png',
};

export enum AllowanceEnums {
  meal = '0',
  travel = '1',
  accommodation = '2',
  emergency = '3',
  others = '4',
}

export enum UmbrellaUserTypes {
  professional = 'Professional',
}

export enum AllowanceTypesToHandle {
  paidAirTicket = '1',
  paidValuePerNight = '2',
}

export enum RatingQuestionType {
  binaryQuestion,
  customQuestion,
}

export type IChannelURLData = {
  users: string;
  user_type: string;
  personnelId: string;
  username: string;
  accessBy: string;
  userId?: string;
};

export type IChannelData = {
  [key: string]: IChannelURLData;
};

export enum ClientChatTypes {
  support = 0,
  pharmacy = 1,
  pharmacist = 2,
  users = 3,
  technician = 4,
  student = 5,
}

export const HelpTypesClientChat = {
  [HelpTypes.pharmacist]: ClientChatTypes.pharmacist,
  [HelpTypes.technicians]: ClientChatTypes.technician,
  [HelpTypes.students]: ClientChatTypes.student,
  [HelpTypes.pharmacy]: ClientChatTypes.pharmacy,
};

export enum NotificationSettingTypes {
  notifyIfSelected = 1,
}

export type capacityIdKey = 'pharmacistCapacityId';

export enum PaymentPlans {
  basic = 'basic',
  unlimited = 'unlimited',
}

export const stripeCurrency = 'cad';

export enum ComparePaymentPlanTypes {
  compare = 'compare',
  upgrade = 'upgrade',
  view = 'view',
}

export enum StripePaymentStatus {
  requiresAction = 'requires_action',
  succeeded = 'succeeded',
  processing = 'processing',
  requirePaymentMethod = 'requires_payment_method',
  canceled = 'canceled',
}

export enum PharmacyBillingPageStatuses {
  existingPaymentPlan,
  showPaymentPlans,
  upgradePlan,
  payment,
}

export enum PaymentStatus {
  None = 0,
  Initiated = 1,
  Processing = 2,
  Success = 3,
  Failure = 4,
}

export enum TransactionTypes {
  Unlimited = 1,
  Basic = 2,
  Refund = 3,
}

export const fallbackText = '-';

export enum RefundStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum TransactionStatus {
  Success = 1,
  Failure = 2,
  Progress = 3,
  Refund = 4,
}

export const bankAccountMaxLengths = {
  institutionNumber: 3,
  branchNumber: 5,
  accountNumber: 9,
};

export const decimalMaxLength = 6;

export enum TravelAllowanceEnums {
  valueKm = '0',
  paidAirTicket = '1',
  travelAmount = '2',
}

export const taxValidationRegex = /^[a-zA-Z0-9\-]*$/;

export const ChannelCustomTypes = {
  usersChat: '1',
};

export type ProfessionalOnlyUsers = Exclude<
  TypeOfUser,
  | TypeOfUser.pharmacy
  | TypeOfUser.admin
  | TypeOfUser.pharmacyAdmin
  | TypeOfUser.superAdmin
>;

export enum ProfessionalReplacementTypes {
  pharmacist = 0,
  technician = 1,
  student = 2,
}

export enum ContractTypes {
  shortTerm = 0,
  longTerm = 1,
}

export enum NotificationPriorities {
  normal = '0',
  critical = '1',
}

export enum Agencies {
  PharmaPlan = '0',
  PharmaGap = '1',
}

export const ShiftSourceItems = [
  {
    key: Agencies.PharmaPlan,
    label: 'PharmaPlan',
  },
  {
    key: Agencies.PharmaGap,
    label: 'PharmaGap',
  },
];

export const ReplacementLabelsStyled = {
  [ProfessionalReplacementTypes.pharmacist]: {
    backgroundColor: '#7D7CFD',
    color: 'white',
  },
  [ProfessionalReplacementTypes.technician]: {
    backgroundColor: '#27B1B4',
    color: 'white',
  },
  [ProfessionalReplacementTypes.student]: {
    backgroundColor: '#EB8276',
    color: 'white',
  },
};

export const SignUpFlowScreens = {
  General: 'General',
  ProfessionalInfo: 'Professional Info',
  Software: 'Software',
  Contact: 'Contact',
  MobileContacts: 'Pharmacy Contacts - Mobile',
  PharmacyInfo: 'Pharmacy Info',
  Coordinates: 'Coordinates',
  Primary: 'Primary',
  Secondary: 'Secondary',
  Accounting: 'Accounting',
  PreferredReplacement: 'Preferred Replacement',
  Operation: 'Operations',
};

export enum PublicRatingType {
  professional,
  pharmacy,
}

export enum SubscriptionType {
  Basic = 1,
  Unlimited = 2,
}

export const toCurrencyFormat = (val: number | string | undefined) =>
  `${currency}${convertToDecimals(val as number)}`;

export const getHourlyLabel = (
  weekday: number | string | undefined,
  weekend: number | string | undefined,
) => {
  if (!weekday) {
    return '(Wknd)';
  } else if (!weekend) {
    return '(Wk)';
  } else {
    return '(Wk/Wknd)';
  }
};

export const minimumSoftwareKnowledge = '75';
export const CrossPlatformAbbreviations = {
  full: 'PP',
  self: 'PG',
};

export const emailLinkedPaths = {
  workshiftDetails: '/workshift-details',
  viewMoreShift: '/view-more-shifts',
  unsubscribeInvitation: '/unsubscribe/professional-booking-invitation',
  unsubscribePostingReminder: '/unsubscribe/pharmacy-posting-reminder',
  joinPharmaPlan: '/join-pharmaplan',
};

export enum UnsubscribeTypes {
  professionalBookingInvitation = 'professional-booking-invitation',
  pharmacyPostingReminder = 'pharmacy-posting-reminder',
}

export const ReplacementHelpTypesMap = {
  [HelpTypes.pharmacist]: ProfessionalReplacementTypes.pharmacist,
  [HelpTypes.technicians]: ProfessionalReplacementTypes.technician,
  [HelpTypes.students]: ProfessionalReplacementTypes.student,
};

export const phonePatternRegex = /^\d{3}-\d{3}-\d{4}$/;

export enum formUrl {
  registrationPopupUrl = 'registrationPopupUrl',
  registrationEmailUrl = 'registrationEmailUrl',
  activationEmailUrl = 'activationEmailUrl',
  bookingEmailUrl = 'bookingEmailUrl',
}

export const broadcastedMessageType = 'Broadcast';

export enum CampaignTypes {
  LeadCampaignInvite,
  UserCreditsInvite,
  Activation,
  SingleBooking,
  ContractBooking,
}
